export var METRIC_COLORS = {
    ACCEPTABLE: '#069A16',
    CAUTION: '#E88B1E',
    OUTSIDE: '#BC0404',
};
export var SLIDER_THUMB_SIZE = 30;
export var SLIDER_TRACK_HEIGHT = 8;
export var SLIDER_STEP = 0.5;
